import { Grid, Typography } from '@mui/material';
import { SimpleShowLayout, TextField } from 'react-admin';
import { Account } from 'src/models';

interface FinancialAssetsProps {
  record: Account;
}

export const FinancialAssets = ({ record }: FinancialAssetsProps) => {
  return (
    <>
      <Grid item md={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Financial Assets </Typography>
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='financialAssets.annualIncome.label' label='Annual Income' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='financialAssets.totalNetWorth.label' label='Total Net Worth' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='financialAssets.liquidNetWorth.label' label='Liquid Net Worth' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='financialAssets.taxBracket.label' label='Tax Bracket' />
        </SimpleShowLayout>
      </Grid>
    </>
  );
};
